<template>
  <div class="fill-height">
    <v-app-bar app flat dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-icon v-else>fad fa-file-spreadsheet</v-icon>
      <v-toolbar-title class="ml-0 pl-3">Reports</v-toolbar-title>
    </v-app-bar>
    <v-content class="grey lighten-2 fill-height">
      <v-container fluid py-0 class="grey lighten-2 fill-height">
        <v-layout class="calc-height fill-height" column>
          <v-flex class="calc-central-height">
            <v-layout fill-height align-center justify-center v-if="loading">
              <v-progress-circular size="70" :width="7" color="accent" indeterminate></v-progress-circular>
            </v-layout>
            <v-layout v-else style="width: 100%">
              <report-card
                v-for="report in Reports"
                :key="report.id"
                :reportId="report.id"
                :reportName="report.name"
                :reportUpdated="report.last_updated"
                :reportType="report.type"
              >
              </report-card>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ReportCard from '@/components/Platform/Reports/ReportCard';

export default {
  components: {
    ReportCard
  },
  data: () => ({
    lastLoaded: 0
  }),
  name: 'Reports',
  computed: {
    ...mapGetters(['UILeftDrawer', 'LoadingReports', 'Reports']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    loading() {
      return this.LoadingReports;
    }
  },
  methods: {
    ...mapActions(['updateUILeftDrawerState', 'getReports'])
  },
  mounted() {
    if (this.LoadingReports === null || Date.now() - this.lastLoaded > 12 * 60 * 60 * 1000) {
      this.getReports();
      this.lastLoaded = Date.now();
    }
  }
};
</script>
